import LanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import LayoutManager from "../../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../../core/ui/AbstractMediator";

export default class TutorialHubMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {LanguagePack} languagePack
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();
        this.preventClickThrough();
        this._target.HubScreenSkin.TimingBG.ChapterLabel.text = this._languagePack.getText('tutorial.hub.HubChapter');
        this._target.HubScreenSkin.TimingBG.WeekLabel.text = this._languagePack.getText('tutorial.hub.HubWeek');
        this._target.HubScreenSkin.timerKeyDecision.textField.text = this._languagePack.getText('tutorial.hub.HubTimer');
        this._updateTextButton(this._target.HubScreenSkin.dashboardButton, "", 'tutorial.hub.HubDashboard', false);
        this._updateTextButton(this._target.HubScreenSkin.teaCorner, "", 'tutorial.hub.HubTeaCorner', false);
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder1, "name", 'tutorial.hub.HubColleague1Name');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder1, "position", 'tutorial.hub.HubColleague1Title');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder2, "name", 'tutorial.hub.HubColleague2Name');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder2, "position", 'tutorial.hub.HubColleague2Title');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder3, "name", 'tutorial.hub.HubColleague3Name');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder3, "position", 'tutorial.hub.HubColleague3Title');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder4, "name", 'tutorial.hub.HubColleague4Name');
        this._updateTextButton(this._target.HubScreenSkin.internalStakeholders.internalStakeholder4, "position", 'tutorial.hub.HubColleague4Title');
    }

    positionDisabledLabelTextField

    _updateTextButton(target, prefix, languageKey, capitalizeButtonState = true) {
        var buttonStates = ["upLabelTextField", "overLabelTextField", "disabledLabelTextField", "downLabelTextField"];
        buttonStates.forEach((buttonState) => {
            var updateButtonState = buttonState;
            if(capitalizeButtonState) {
                updateButtonState = updateButtonState.charAt(0).toUpperCase()+ updateButtonState.slice(1);
            }
            target[prefix + updateButtonState].text = this._languagePack.getText(languageKey);
        });
    }
}